import { useToast } from "@/hooks/useToast";
import { useState, useCallback } from "react";

type FetchOptions = RequestInit & { body?: any };

export function useApi<T = any>() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);
	const [ok, setOk] = useState(false);
	const { addToast, removeLoading } = useToast();

	const call = useCallback(
		async (
			url: string,
			options: FetchOptions = {},
			needToast = false
		): Promise<T | null> => {
			setLoading(true);
			setError(null);
			try {
				if (needToast) {
					addToast("درحال بارگذاری", "loading");
				}
				const res = await fetch(url, {
					...options,
					headers: {
						"Content-Type": "application/json",
						...(options.headers || {}),
					},
					body: options.body ? options.body : undefined,
				});
				removeLoading();
				if (res.status === 401 && needToast) {
					addToast("ابتدا باید وارد حساب کاربری خود شوید", "error");
					return null;
				}

				if (!res.ok) {
					const text = await res.text();
					setError(text || "Unknown error");
					return null;
				}
				setOk(true);
				return (await res.json()) as T;
			} catch (err: any) {
				setError(err.message || "Network error");
				return null;
			} finally {
				setLoading(false);
			}
		},
		[]
	);

	return { call, loading, error, ok };
}
